<template>
  <!--  tabindex="-1"-->
  <div class="modal fade custom-modal" :class="classes" :id="target" role="dialog" aria-labelledby="modal-label" data-backdrop="static" data-keyboard="false" aria-hidden="true">
    <div class="modal-dialog" :class="sizeClass" role="document">
      <div class="modal-content">
        <div class="modal-header d-flex">
          <h5 class="modal-title flex-grow-1" id="modal-label">{{modalTitle}}</h5>

          <button type="button" class="close" @click="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-if="hasBody" class="modal-body">
          <slot name="body"></slot>
        </div>
        <div v-if="hasSlot('footer')" class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn btn-outline-gray" @click="close">
              {{Lang.get('messages.cancel')}}
            </button>
            <button type="button" class="btn btn-danger" @click="confirm" :disabled="button_status">
              {{Lang.get('messages.confirm')}}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    button_status: {
      type: Boolean,
      default:false
    },

    target: {
      type: String,
      required: true
    },

    size: {
      validator: function (value) {
        // The value must match one of these strings
        return ['xl', 'lg', 'sm', 'md'].indexOf(value) !== -1
      }
    },
    classes: {
      type:Object,
      default: function () {
        return {};
      }
    },
    hideFooter: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      modalTitle: this.title
    }
  },

  computed: {
    sizeClass() {
      return this.size ? `modal-${this.size}` : '';
    },

    hasFooter() {
      return !!this.$slots.footer;
    },

    hasBody() {
      return this.hasSlot("body");
    },
  },

  methods: {
    hasSlot(name = "default") {
      return !!this.$slots[name] || !!this.$scopedSlots[name];
    },

    open(title = null) {
      this.button_status = false;
      if (title) {
        this.modalTitle = title;
      }

      $(`#${this.target}`).modal("show");
    },

    close() {
      $(`#${this.target}`).modal("hide");
      this.$emit('modal-closed');

      this.$children.forEach(child => {
        if (child._data && child._data.hasOwnProperty('formErrors')) {
          child._data.formErrors = {};
        }
      })
    },

    confirm(payload) {
      this.button_status = true;
      this.$emit("confirm",payload);
    },

    enableButton() {
      this.button_status = false;
    }
  }
};
</script>

<style>
.h-scroll {
  overflow-x: auto;
}
</style>